// extracted by mini-css-extract-plugin
module.exports = {"navBlockActive":"navBlockActive__1WZ5L","navBlockInactive":"navBlockInactive__2q0_2","navList":"navList__2A-p0"};